// Shared landing palette + type stack (AudiNexa V3 landing).
export const C = {
  bone: '#FDFBF7',
  surface: '#F3F1EC',
  ink: '#1A1C23',
  ink2: '#4A4D57',
  saffron: '#D95D39',
  saffronHover: '#B84A2A',
  saffronTint: '#FEF0EA',
  emerald: '#059669',
  emeraldTint: '#DCFCE7',
  border: '#E2DFD8',
  navy: '#0B0D17',
  navySurface: '#151828',
};

export const F = {
  display: '"Cabinet Grotesk", "Inter", system-ui, sans-serif',
  body: '"IBM Plex Sans", system-ui, sans-serif',
  mono: '"IBM Plex Mono", ui-monospace, monospace',
};
